<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-7">
                                <div class="row">
                                    <div class="col-md-12">
                                        <input type="file" id="file-user-costcenter-massive-update" required/>
                                    </div>
                                    <div class="col-md-12">
                                        <p class="text-primary mt-2"><i>El archivo Excel debe tener dos columnas (La primera para el Centro de Costo y la segunda para el Email). <br/>El sistema procesará desde la segunda fila</i></p>
                                    </div>
                                    <div class="col-md-12">
                                        <button @click="upload" class="btn mt-4 btn-block btn-success">
                                            <i class="fa fa-save"></i>
                                            Procesar
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <table v-if="result" class="table table-sm">
                                    <tr>
                                        <th>Total</th>
                                        <td>{{ result.rowCount }}</td>
                                    </tr>
                                    <tr>
                                        <th>Registros Correctos</th>
                                        <td>{{ result.successCount }}</td>
                                    </tr>
                                    <tr>
                                        <th>Registros Erróneos</th>
                                        <td>{{ result.errorCount }}</td>
                                    </tr>
                                </table>
                            </div>                         
                        </div>
                    </div>
                </div>
            </div> 
        </div>    
        <div v-if="result.errors" class="row mt-4">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <b>Errores</b>
                    </div>
                    <div class="card-body">
                        <table class="table table-striped table-bordered">
                            <tr v-for="e in result.errors" :key="e">
                                <td class="bg-light-danger">{{ e }}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Put, Get } from "../../helper/axios.js";
export default {
    data() {
        return {
            apiUrl: this.$store.getters.apiUrl,
            Get,
            Put,
            user: {},
            userSelected: [],
            result: {}
        };
    },
    methods: {
        resetView() {
            this.result = {};
            this.userSelected = [];
            this.user = {};
            const fileInput = document.getElementById("file-user-costcenter-massive-update");
            if (fileInput) {
                fileInput.value = null;
            }
        },
        upload() {
            let formData = new FormData();
            let file = document.getElementById("file-user-costcenter-massive-update");

            if (file)
            {
                file = file.files[0];
                formData.append("file", file);
                try {
                    this.$store.commit("setLoading", true);
                    this.Put(`${this.apiUrl}v1/CostCenterUsers/massiveUserCostCenterUpdate`, formData, (res) => {
                        this.$store.commit("setLoading", false);
                        this.result = res.data.data
                        if (res.data.data === 200)
                            window.toastr.success("Se ha procesa la carga masiva de Usuarios y Centros de Costos correctamente.");
                        //this.$emit("updateDone", true);
                });
                } catch (error) {
                    alert("Error al procesar el archivo.");
                    console.error(error);
                }
            }
        }
    }
};
</script>
